export default (configuration, item) => {
  // If we have any entries in the configuration
  if (Object.keys(configuration.config)) {
    return configuration.config[item];
  }
  return undefined;
};
